import script from "./CourseMaterialItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseMaterialItem.vue?vue&type=script&setup=true&lang=js"

import "./CourseMaterialItem.vue?vue&type=style&index=0&id=052d8fe9&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052d8fe9"]])

export default __exports__